import type { AutoCompleteDesignTokens, AutoCompleteTokenSections } from '@primeuix/themes/types/autocomplete';

export const root: AutoCompleteTokenSections.Root = {
    background: '{formField.background}',
    disabledBackground: '{formField.disabledBackground}',
    filledBackground: '{formField.filledBackground}',
    filledHoverBackground: '{formField.filledHoverBackground}',
    filledFocusBackground: '{formField.filledFocusBackground}',
    borderColor: '{formField.borderColor}',
    hoverBorderColor: '{formField.hoverBorderColor}',
    focusBorderColor: '{formField.focusBorderColor}',
    invalidBorderColor: '{formField.invalidBorderColor}',
    color: '{formField.color}',
    disabledColor: '{formField.disabledColor}',
    placeholderColor: '{formField.placeholderColor}',
    invalidPlaceholderColor: '{formField.invalidPlaceholderColor}',
    shadow: '{formField.shadow}',
    paddingX: '{formField.paddingX}',
    paddingY: '{formField.paddingY}',
    borderRadius: '{formField.borderRadius}',
    focusRing: {
        width: '{formField.focusRing.width}',
        style: '{formField.focusRing.style}',
        color: '{formField.focusRing.color}',
        offset: '{formField.focusRing.offset}',
        shadow: '{formField.focusRing.shadow}'
    },
    transitionDuration: '{formField.transitionDuration}'
};

export const overlay: AutoCompleteTokenSections.Overlay = {
    background: '{overlay.select.background}',
    borderColor: '{overlay.select.borderColor}',
    borderRadius: '{overlay.select.borderRadius}',
    color: '{overlay.selectColor}',
    shadow: '{overlay.select.shadow}'
};

export const list: AutoCompleteTokenSections.List = {
    padding: '{list.padding}',
    gap: '{list.gap}'
};

export const option: AutoCompleteTokenSections.Option = {
    focusBackground: '{list.option.focus.background}',
    selectedBackground: '{list.option.selectedBackground}',
    selectedFocusBackground: '{list.option.selectedFocusBackground}',
    color: '{list.option.color}',
    focusColor: '{list.option.focusColor}',
    selectedColor: '{list.option.selectedColor}',
    selectedFocusColor: '{list.option.selectedFocusColor}',
    padding: '{list.option.padding}',
    borderRadius: '{list.option.borderRadius}'
};

export const optionGroup: AutoCompleteTokenSections.OptionGroup = {
    background: '{list.optionGroup.background}',
    color: '{list.optionGroup.color}',
    fontWeight: '{list.optionGroup.fontWeight}',
    padding: '{list.optionGroup`.padding}'
};

export const dropdown: AutoCompleteTokenSections.Dropdown = {
    width: '2.5rem',
    sm: {
        width: '2rem'
    },
    lg: {
        width: '3rem'
    },
    borderColor: '{formField.borderColor}',
    hoverBorderColor: '{formField.hoverBorderColor}',
    activeBorderColor: '{formField.activeBorderColor}',
    borderRadius: '{formField.borderRadius}',
    focusRing: {
        width: '{formField.focusRing.width}',
        style: '{formField.focusRing.style}',
        color: '{formField.focusRing.color}',
        offset: '{formField.focusRing.offset}',
        shadow: '{formField.focusRing.shadow}'
    }
};

export const chip: AutoCompleteTokenSections.Chip = {
    borderRadius: '{borderRadius.sm}'
};

export const emptyMessage: AutoCompleteTokenSections.EmptyMessage = {
    padding: '{list.option.padding}'
};

export const colorScheme: AutoCompleteTokenSections.ColorScheme = {
    light: {
        chip: {
            focusBackground: '{surface.200}',
            focusColor: '{surface.800}'
        },
        dropdown: {
            background: '{surface.100}',
            hoverBackground: '{surface.200}',
            activeBackground: '{surface.300}',
            color: '{surface.600}',
            hoverColor: '{surface.700}',
            activeColor: '{surface.800}'
        }
    },
    dark: {
        chip: {
            focusBackground: '{surface.700}',
            focusColor: '{surface.0}'
        },
        dropdown: {
            background: '{surface.800}',
            hoverBackground: '{surface.700}',
            activeBackground: '{surface.600}',
            color: '{surface.300}',
            hoverColor: '{surface.200}',
            activeColor: '{surface.100}'
        }
    }
};

export default {
    root,
    overlay,
    list,
    option,
    optionGroup,
    dropdown,
    chip,
    emptyMessage,
    colorScheme
} satisfies AutoCompleteDesignTokens;
